module.exports = __webpack_public_path__ + "static/media/quiz-hint-2-en.d7c00b6c.vtt";